import type { RouteLocation } from 'vue-router'
import { useAuthStore } from '@/stores/AuthStore'
import { areas } from '@/router/areas'
import { Nfc } from '@capawesome-team/capacitor-nfc'

export async function adminMiddleware(to: RouteLocation, from: RouteLocation) {
  console.log('adminMiddleware')
  const authStore = useAuthStore()

  const leavingAdminArea =
    from.meta.area === areas.MULTI_USER_ADMIN_AREA &&
    to.meta.area !== areas.MULTI_USER_ADMIN_AREA

  const enteringAdminArea =
    from.meta.area !== areas.MULTI_USER_ADMIN_AREA &&
    to.meta.area === areas.MULTI_USER_ADMIN_AREA

  if (leavingAdminArea) {
    console.log('adminMiddleware logging out user')
    // make sure the admin nfc scanning behavior is deactivated on other pages
    await Nfc.stopScanSession()
    await Nfc.removeAllListeners()
    await authStore.logoutUser()
  }

  if (enteringAdminArea) {
    console.log('trying to enter Admin area')
    if (!authStore.userIsAuthenticated) return false
    // make sure the default nfc scanning behavior is deactivated on the admin page
    await Nfc.stopScanSession()
    await Nfc.removeAllListeners()
  }

  if (authStore.isTerminalDevice && !to.meta.area) {
    await authStore.logoutUser()
  }

  return true
}
